import {Component, EventEmitter, Input, input, Output, ChangeDetectionStrategy} from '@angular/core';
import {WaButtonDirective, WaIconDirective} from "angular-awesome";
import {StaffMember} from "../../../../api/models/staff-member";

@Component({
  selector: 'app-correction-excluded-staff-member',
    imports: [
        WaButtonDirective,
        WaIconDirective
    ],
  templateUrl: './correction-excluded-staff-member.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './correction-excluded-staff-member.component.scss',
})
export class CorrectionExcludedStaffMemberComponent {

  staffmember = input.required<StaffMember>();
  @Output() unexclude = new EventEmitter<StaffMember>();

}
